import { useRef, useCallback, useState } from 'react';
import useToggle from 'react-use/lib/useToggle';
import useClickAway from 'react-use/lib/useClickAway';
import Icon from 'components/Kizen/Icon';
import Button from 'components/Button';
import { useTranslation } from 'react-i18next';
import { ButtonMenu, Wrapper } from './styles';
import { ICON_BUTTON_DELAY, useTooltip } from 'components/Kizen/Tooltip';
import { CustomObjectHistoryModal } from 'pages/CustomObjects/CustomObjectHistoryModal';

export const SettingsButton = ({
  color = 'green',
  disabled = false,
  options,
  onClick = null,
  onChange = null,
  children,
  variant = 'default',
  customObjectId,
  ...others
}) => {
  const { t } = useTranslation();
  const [open, toggleOpen] = useToggle(false);
  const [showObjectHistory, setShowObjectHistory] = useState(false);
  const dropdownRef = useRef(null);
  useClickAway(dropdownRef, () => toggleOpen(false));

  const handleChange = useCallback(
    (value) => {
      toggleOpen(false);
      if (value?.value === 'history') {
        setShowObjectHistory(true);
      } else if (onChange) {
        onChange(value);
      }
    },
    [toggleOpen, onChange]
  );
  const [tooltipProps, tooltip] = useTooltip({
    label: t('Settings'),
    delay: ICON_BUTTON_DELAY,
  });

  return (
    <Wrapper ref={dropdownRef} {...others}>
      <Button
        variant={variant}
        color={color}
        disabled={disabled}
        onClick={toggleOpen}
        title={t('Settings')}
        {...tooltipProps}
        data-qa="custom-object-settings-button"
      >
        <Icon icon="cog" color="inherit" />
        <Icon icon="down" color="inherit" />
      </Button>
      {open && !disabled && (
        <ButtonMenu
          classNamePrefix="ButtonMenu"
          menuIsOpen
          menuPlacement="bottom"
          filterOption={null}
          hideSelectedOptions={false}
          options={options}
          onChange={handleChange}
          {...others}
        />
      )}
      {showObjectHistory && customObjectId ? (
        <CustomObjectHistoryModal
          id={customObjectId}
          onHide={() => setShowObjectHistory(false)}
        />
      ) : null}
      {tooltip}
    </Wrapper>
  );
};
